import type {
  CreateClientLeaveTypeRequest,
  CreateClientLeaveTypeRequestAPI,
  GetClientLeaveTypesResponse,
  GetClientLeaveTypesResponseAPI,
  GetClientSetupStatusResponse,
  GetClientSetupStatusResponseAPI,
} from '@omnipresentgroup/types';

export const transformGetClientSetupStatusResponseFromAPI = ({
  time_off_editing_method,
  date_time_format,
}: GetClientSetupStatusResponseAPI): GetClientSetupStatusResponse => ({
  timeOffEditingMethod: time_off_editing_method,
  dateTimeFormat: date_time_format,
});

export const transformGetClientSetupStatusResponseToAPI = ({
  timeOffEditingMethod,
  dateTimeFormat,
}: GetClientSetupStatusResponse): GetClientSetupStatusResponseAPI => ({
  time_off_editing_method: timeOffEditingMethod,
  date_time_format: dateTimeFormat,
});

export const transformGetClientLeaveTypesFromAPI = ({
  items,
  total,
  page,
  size,
  pages,
}: GetClientLeaveTypesResponseAPI): GetClientLeaveTypesResponse => ({
  items: items.map(({ id, leave_type, original_leave_type }) => ({
    id,
    leaveType: leave_type,
    originalLeaveType: original_leave_type,
  })),
  total,
  page,
  size,
  pages,
});

export const transformCreateClientLeaveTypeRequestToAPI = ({
  leaveType,
  originalLeaveType,
}: Partial<CreateClientLeaveTypeRequest>): Partial<CreateClientLeaveTypeRequestAPI> => ({
  op_leave_type: leaveType,
  original_leave_type: originalLeaveType,
});
